'use client';

import React, { useEffect, useState } from 'react';
import RevenueDashboardSection from '../components/dashboard/RevenueDashboard';
import { getFullName } from '../apiHelper';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../hooks/useToast';
import CashFlowLiquidityDashboard from '../components/dashboard/CashFlowLiquidityDashboard';
import CashToCashDashboard from '../components/dashboard/CashToCashDashboard';
import VendorPriceLagDashboard from '../components/dashboard/VendorPriceLagDashboard';
import CustomerRiskDashboard from '../components/dashboard/CustomerRiskDashboard';
import GoodsReceiptAlignmentDashboard from '../components/dashboard/GoodsReceiptAlignmentDashboard';
import InvisibleProfitDashboard from '../components/dashboard/InvisibleProfitDashboard';
import VendorPivotPointDashboard from '../components/dashboard/VendorPivotPointDashboard';

const MainDashboard = () => {
    const navigate = useNavigate();
    const { showToast } = useToast();
    const [user, setUser] = useState(null);

    // Global filters (can be passed down later via Context)
    const [globalFilters, setGlobalFilters] = useState({
        start_date: '2026-03-01',
        end_date: '2026-04-13',
        store_id: '',
    });

    useEffect(() => {
        const lcUser = localStorage.getItem("user");
        if (!lcUser) {
            console.warn("User not found in local storage. Please log in.");
            navigate('/login');
        } else {
            setUser(JSON.parse(lcUser));
        }
    }, []);

    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return 'Good morning';
        if (hour < 17) return 'Good afternoon';
        return 'Good evening';
    };

    return (
        <div className="min-h-screen bg-gray-50 pb-12">

            <div className="max-w-screen-2xl mx-auto px-8 pt-10">
                {/* Welcome Header */}
                <div className="mb-12">
                    <h2 className="text-4xl font-bold text-gray-900">
                        {getGreeting()}, {getFullName(user)} <span className="wave">👋</span>
                    </h2>
                    <p className="text-gray-600 mt-2 text-lg">
                        Here's a comprehensive view of your business performance.
                    </p>
                </div>

                {/* Dashboard Grid - Origami Style */}
                <div className="grid grid-cols-12 gap-8">

                    {/* ==================== REVENUE (Prominent) ==================== */}
                    <div className="col-span-12 xl:col-span-8">
                        <RevenueDashboardSection />
                    </div>

                    <div className="col-span-12 xl:col-span-4 bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
                        <CustomerRiskDashboard />
                    </div>

                    <div className="col-span-12">
                        <CashFlowLiquidityDashboard />
                    </div>

                    <div className="col-span-12">
                        <CashToCashDashboard />
                    </div>

                    <div className="col-span-12">
                        <VendorPriceLagDashboard />
                    </div>



                    {/* ==================== BOTTOM ROW ==================== */}
                    <div className="col-span-12 grid grid-cols-12 gap-8 mt-4">

                        {/* Vendor Pivot */}
                        <div className="col-span-12 md:col-span-5 bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
                            <GoodsReceiptAlignmentDashboard />
                        </div>

                        {/* Customer Risk */}
                        <div className="col-span-12 md:col-span-4 bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
                            <VendorPivotPointDashboard />
                        </div>

                        {/* Hidden Profit */}
                        <div className="col-span-12 md:col-span-3 bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
                            <InvisibleProfitDashboard />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainDashboard;